import { DriverSocketMsg, DriverSocketMsgType } from '@libs/types/message'
import { configSet } from './config_set'
import { EXEDriver } from '../exe/driver.exe'
import { DeviceManager, DeviceProtocol } from '../device'
import { WebDriver } from '../web/driver.web'
import { ResDeviceState, UsingDeviceData } from '@libs/types/response'
import { DevicePid, KK, VK, kks } from '@/define/define'
import { setData } from './data'
import firmware from '@/upgrade/firmware'
import { speciaBehiver, specialCheck, specialCheckCurrent } from '@/define/limit'
import { calibrationHandler } from './calibration_set'
import { HelperService } from '../helper/helper'
import { HelperSocketMsgType } from '../helper/message'
import { STORAGE_KEYS } from '@libs/define/storage_key'
import { setOrRead } from './set_read'
import { SpecificItem } from '@libs/types/enum'

export class DriverService {
  static instance = new DriverService()
  private webDriver = new WebDriver()
  exeDriver = new EXEDriver()

  private get getSocketService() {
    return DeviceManager.instance.state.driverProtocol == DeviceProtocol.dll_exe ? this.exeDriver.socketService : this.webDriver.socketService
  }

  askType<U>(t: DriverSocketMsgType | HelperSocketMsgType): Promise<U> {
    return this.getSocketService.askType<U>(t)
  }
  askTypeAndData<U>(msg: DriverSocketMsg<any>): Promise<U> {
    return this.getSocketService.askTypeAndData<U>(msg)
  }
  setHandler(messageType: DriverSocketMsgType | HelperSocketMsgType, onSuccess: (data: any) => void, onFailure?: (error: any) => void) {
    return this.getSocketService.setHandler(messageType, onSuccess, onFailure)
  }

  async initializeDevice() {
    try {
      const res = await this.getSocketService.askType<UsingDeviceData>(DriverSocketMsgType.MTUsingDevice)
      await this.askDeviceRelatedDataInfo()
      if (res) {
        DeviceManager.instance.setCurrentDevice(res.ID)
        if (DeviceManager.instance.state.currentDevice.IsSupportMagnet) {
          calibrationHandler.initCalibration()
        }
        await this.checkMer68SEFirstUse()
      }
      this.handleConfig()
      this.askConfigData()
      this.askCurrentDeviceState()
    } catch (error) {
      console.error('askDeviceInfo failed:', error)
    }
  }

  private async checkMer68SEFirstUse() {
    if (specialCheckCurrent(speciaBehiver.DevicesOfSelfDevMagnet)) {
      const key = `${STORAGE_KEYS.MER68SE_FIRST_USE}_${DeviceManager.instance.state.currentPid}`
      const isFirstUse = localStorage.getItem(key)
      if (!isFirstUse) {
        try {
          const isKeyModeOn = await setOrRead.read<boolean>(SpecificItem.SuperResponsiveMode, false)
          if (isKeyModeOn) {
            await setOrRead.write(SpecificItem.SuperResponsiveMode, false)
            console.log('MER68SE first use: Keyboard Mode Switch turned off')
          }
          localStorage.setItem(key, 'true')
        } catch (error) {
          console.error('checkMer68SEFirstUse error:', error)
        }
      }
    }
  }

  // 读取设备固件信息，并检查是否需要更新
  // 读取设备按键的kk和vk
  // 读取设备存档数据
  private async askDeviceRelatedDataInfo() {
    firmware.checkFirmwareUpdate()
    await this.askDeviceKeys()
    await setData.askData()
  }

  private async askDeviceKeys() {
    kks.value = await this.getSocketService.askType<{ [index: KK]: VK }>(DriverSocketMsgType.MTGetDefineKeys)
  }

  // 接受设备状态
  private async askCurrentDeviceState() {
    if (specialCheck(speciaBehiver.SupportGetDeviceStatus, DeviceManager.instance.state.currentPid) == false) {
      return
    }
    const res = await this.askType<ResDeviceState>(DriverSocketMsgType.MTDeviceState)
    if (res) {
      DeviceManager.instance.state.deviceStatus = res
    }
  }

  async askToSelect(pid: DevicePid) {
    const data = { Type: DriverSocketMsgType.MTSelectDevice, Data: pid } as DriverSocketMsg<any>
    return await this.getSocketService.askTypeAndData(data)
  }

  private handleConfig() {
    // TODO: 不应该多次handel，需修改
    configSet.handelChangeConfig()
    configSet.handelSwitchConfig()
  }

  private askConfigData() {
    configSet.getConfigRecommend()
    configSet.apiConfigList()
  }

  askDeviceVersion = (): Promise<string> => {
    return this.getSocketService.askType<string>(DriverSocketMsgType.MTDeviceVersion)
  }

  lanuchNcus() {
    return HelperService.instance.launchEEvision()
  }

  killDriverService() {
    this.exeDriver.killDriverService()
  }
}
